export const codeOfConductStudentsLink =
  'https://studentconduct.rutgers.edu/processes/university-code-student-conduct'

export const codeOfConductEmployeesLink =
  'https://uec.rutgers.edu/policies/ethics-code-of-conduct/'
